import Marquee from "react-fast-marquee";

const WORDS = [
  "Conscious Luxury",
  "Kasauli Hills",
  "8 Private Acres",
  "Hill-View Residences",
  "Pure Mountain Air",
];

export default function Ribbon() {
  return (
    <div
      data-testid="ribbon"
      className="relative border-y border-[#d4af37]/15 bg-[#070707] py-6 md:py-8"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-word text-3xl md:text-5xl text-[#f5f5f0]/90 px-8 font-light italic">
              {w}
            </span>
            <span className="text-[#d4af37] text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
